import React, { useContext, useEffect, useRef, useState } from 'react';  
import AuthContext from '../contex/AuthProvider';  
import axios from '../api/axios';  
import AxiosInstance from '../hooks/AxiosInstance';
import { useNavigate } from 'react-router-dom';  
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import Logo from '../assets/ML REVIEWED.png';
import '../Style/LoginSignUp.css';
import { useToken } from '../contex/TokenProvider';



const LOGIN_URL = '/Users/Login';  

const LoginSignUp = () => {  
    const {auth, setAuth } = useContext(AuthContext);  
    const { setToken } = useToken();
    const userRef = useRef();  
    const errRef = useRef();  
    const navigate = useNavigate();  

    const [form, setForm] = useState({  
        email: '',  
        password: ''  
    });  
    const [loading, setLoading] = useState(false);   
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {  
        userRef.current.focus();  
    }, []);  

    const handleChange = (e) => {  
        const { name, value } = e.target;  
        setForm((prevForm) => ({ ...prevForm, [name]: value }));  
    };  

    const handleSubmit = async (e) => {   
        e.preventDefault();  
        setLoading(true);   
        setErrorMessage('');  
        try {  
            const response = await AxiosInstance.post(LOGIN_URL, {  
                email: form.email,   
                password: form.password     
            });   
        
            const token = response.data?.data.token; // Extract token  
            const user = response.data?.data.user; // Extract user data  
    
            if (token) {  
                //localStorage.setItem('token', token); // Store token 
                setToken(token); // was: localStorage.setItem('token', token) 
                setAuth({ user }); // Store user data in context  
                navigate('/home');  
            } else {  
                throw new Error('No token received');  
            }  
        } catch (err) {  
            let mess = ''; // Default error message  
            if (err.response) {  
                if (err.response.status === 401) {  
                    mess = 'An unexpected error occurred. Please try again.';  
                }  
            }  
            setErrorMessage(err.response?.data.message || mess);   
        } finally {  
            setLoading(false);  
        }   
    };
    
    return (  
        <section className='login relative mx-auto py-[100px] flex flex-row gap-20 justify-center items-center h-[100vh] px-[200px] bg-green-100'> 
            
            <form onSubmit={handleSubmit} className='flex flex-col gap-5 justify-center items-center border-2 border-green-600 py-10 px-20 rounded-2xl shadow-xl bg-slate-300'>  
                <img src={Logo} className='w-[200px]' />
                <p>Welcome to Mercyland Group Admin</p>
                <h1 className='font-bold text-[25px] text-slate-700'>Sign In</h1>  
                  
                {errorMessage && <p ref={errRef} className='text-red-500'>{errorMessage}</p>}
                <div className='flex flex-col'>  
                    <label htmlFor='email' className=' font-bold'>Email*</label>  
                    <input   
                        type='text'  
                        id='email'  
                        ref={userRef}  
                        autoComplete='off'  
                        onChange={handleChange}  
                        name='email'  
                        value={form.email}  
                        required  
                        className='py-2 px-5 rounded-lg outline-none'  
                    />  
                </div>  
                
                <div className='flex flex-col'>  
                    <label htmlFor='password' className=' font-bold'>Password*</label>  
                    <input   
                        type='password'  
                        id='password'  
                        onChange={handleChange}  
                        name='password'  
                        value={form.password}  
                        required  
                        className='py-2 px-5 rounded-lg'  
                    />  
                </div>  
                
                <button disabled={loading} type="submit" className='py-3 px-5 bg-green-500 active:bg-green-500 hover:bg-green-700 rounded-lg text-white text-[18px]'>
                    {loading ? <AiOutlineLoading3Quarters className='loading text-[25px]'/> : 'Sign In'}
                </button>  
                
       
            </form>  
        </section>  
    );  
};  

export default LoginSignUp;